import { planTypes } from '@/common/constants';

export default {
  data() {
    return {
      title: this.$t('billing.video_sdk_uc.title'),
      subtitle: this.$t('billing.video_sdk_uc.subtitle_new'),
      logo: require('@/assets/plans/sdkuc.svg'),
      trackingPlanName: this.$t('billing.video_sdk_uc.title'),
      planType: planTypes.VIDEO_SDK_UC,
    };
  },
};
